import React from 'react';

interface IconHangerProps {}

type Props = React.FC<React.HTMLAttributes<HTMLOrSVGElement> & IconHangerProps>;

const IconHanger: Props = ({ className, ...props }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`h-16 w-16 fill-current text-black ${className ? className : ''}`}
    >
      <title>Clothing Hanger</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.543 4l7.31 3.303.026.013c.17.088.43.222.648.405.226.19.473.488.473.907 0 .367-.074.737-.338 1.01-.271.28-.647.362-1.018.362H1.356c-.37 0-.747-.081-1.018-.361C.074 9.365 0 8.995 0 8.628c0-.42.248-.718.473-.907.218-.183.479-.317.648-.405l.015-.007L7.543 4zm.028 1.022L1.577 8.117a2.712 2.712 0 00-.489.297c-.129.108-.147.175-.147.214 0 .273.06.36.083.384.017.017.083.073.332.073h13.288c.248 0 .315-.056.332-.073.024-.024.083-.111.083-.384 0-.039-.018-.106-.147-.214a2.654 2.654 0 00-.478-.292l-6.863-3.1z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.391.424C6.674.118 7.067 0 7.5 0c.376 0 .753.127 1.04.41.293.29.46.708.46 1.215 0 .378-.088.684-.235.931-.144.243-.331.407-.494.525a4.053 4.053 0 01-.227.15l-.01.006c-.065.041-.112.07-.15.098a.707.707 0 00-.009.006V5h-.75V3.25c0-.331.237-.515.343-.591a3.38 3.38 0 01.2-.131c.066-.042.127-.08.186-.123a.97.97 0 00.28-.288.93.93 0 00.116-.492c0-.305-.095-.495-.215-.613a.75.75 0 00-.535-.2c-.317 0-.486.086-.579.186-.092.1-.171.284-.171.627H6c0-.469.108-.895.391-1.201z"
      />
    </svg>
  );
};

export default IconHanger;
